import React from "react";
import { Title } from "../Title";
import style from "./Portfolio.module.css";
import { SORTED_PORTFOLIO_LIST } from "../../common";
import { Image } from "../../ui";

export const Portfolio = () => {
  return (
    <div className={style.portfolioContainer}>
      <div className={"container"}>
        <Title as="h1" title="Our projects" />
        <div className={style.portfolioList}>
          {SORTED_PORTFOLIO_LIST.map(({ title, text, alt, img, id }) => (
            <Image
              key={id}
              title={title}
              text={text}
              alt={alt}
              img={img}
              id={id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
